import { FC, memo } from "react";
import { Pressable } from "react-native";
import { View, Text } from "@src/components";
import { Icon } from "@src/components/Icon";
import { useUnistyles } from "react-native-unistyles";

type StreamStateViewProps = {
  title: string;
  message: string;
  onRetry: () => void;
};

/**
 * Generic error/timeout state overlay for livestream playback.
 * Used by StreamErrorView and StreamTimeoutView — only the title and message differ.
 */
export const StreamStateView: FC<StreamStateViewProps> = memo(({ title, message, onRetry }) => {
  const { theme } = useUnistyles();

  return (
    <View
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        padding: theme.spacing["3xl"],
      }}
    >
      <Icon
        name="errorOutline"
        size={64}
        color={theme.colors.white.default}
        style={{ marginBottom: theme.spacing.xl }}
      />
      <Text textStyle="lg/bold" style={{ color: theme.colors.white.default, textAlign: "center" }} mb="lg">
        {title}
      </Text>
      <Text textStyle="md/regular" style={{ color: theme.colors.grey[400], textAlign: "center" }} mb="xl">
        {message}
      </Text>
      <Pressable
        onPress={onRetry}
        style={{
          paddingHorizontal: theme.spacing["2xl"],
          paddingVertical: theme.spacing.lg,
          backgroundColor: theme.colors.white.default,
          borderRadius: theme.spacing.md,
        }}
      >
        <Text textStyle="md/semibold" style={{ color: "black" }}>
          Retry
        </Text>
      </Pressable>
    </View>
  );
});

StreamStateView.displayName = "StreamStateView";
